import { Pipe, PipeTransform } from '@angular/core';

import {convertOnlyTimeFromUTCToUserTimezoneTEXT} from '../../base-functions/as-timezones.base-function';

@Pipe({ name: 'acOnlyTimePIPE' })
export class OnlyTimePipeAC implements PipeTransform {
    transform(value: any): String {
        return convertOnlyTimeFromUTCToUserTimezoneTEXT(value);
    }
}